module.exports = __webpack_public_path__ + "static/media/findingAHome2007.872d7ac3.jpg";